import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type Response = paths['/api/lux-loyalty/custom-rules']['get']['responses']['200']['content']['application/json']
type ActiveCustomRule = Response['result']['customRules'][number]

async function requestLoyaltyActiveCustomRules(): Promise<Array<ActiveCustomRule>> {
  const response = await requestUtils.get<Response>('/api/lux-loyalty/custom-rules?status=active', {
    excludeBrand: true,
  })
  return response.result.customRules
}

export default requestLoyaltyActiveCustomRules
